//
//
//
//
//
//
//
//
export default {
  name: 'u8-info-item',
  props: {
    label: {
      default: ''
    },
    info: {
      default: ''
    },
    emptyChar: {
      default: '--'
    }
  },
  methods: {
    onIconClick: function onIconClick() {
      this.$emit('click');
    }
  }
};